module.exports = __webpack_public_path__ + "static/media/pl-flag.562edca5.svg";